module.exports = __webpack_public_path__ + "static/media/2-row-icon.0e0104a3.svg";